import { Site, SiteEntryProps } from '@ixicare/resources';
import { useQuery } from '@tanstack/react-query';

export const useSite: (siteUuid?: string) => SiteEntryProps | undefined = (siteUuid) => {
  const { data: site } = useQuery({
    queryKey: ['site', siteUuid],
    queryFn: () => Site.getSite(siteUuid ?? -1),
    enabled: siteUuid !== undefined,
  });

  return site;
};
